/**
 * CleverTap web push: service worker + soft prompt (`notifications.push`).
 * CleverTap SDK init, events, and `onUserLogin` identity are unaffected when false.
 */
export function isCleverTapWebPushEnabled(): boolean {
    return process.env.NEXT_PUBLIC_CLEVERTAP_PUSH_ENABLED === "true";
}
